import apiFetch from '../apiFetch'

export default function (listTipoDosis, token) {
  return apiFetch({endPoint: `TipoDosis/deleteSeleccionTipoDosis`, method: 'POST', body: listTipoDosis, token: token})
}
